import { render, staticRenderFns } from "./common_header.vue?vue&type=template&id=c1940e1e&scoped=true&lang=pug"
import script from "./common_header.vue?vue&type=script&setup=true&lang=js"
export * from "./common_header.vue?vue&type=script&setup=true&lang=js"
import style0 from "./common_header.vue?vue&type=style&index=0&id=c1940e1e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1940e1e",
  null
  
)

export default component.exports